import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { UserName } from "../../../Users/shared/UserName.js";
import { LocationName } from "../LocationName.js";
import { useAppInteractionHandlers } from "../../../AppWrapper2/hooks/useAppInteractionHandlers.js";
import { useLocationLogEntry } from "../../hooks/useLocationLogEntry.js";
import "react";
import { Card, ColorSquare, Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntryCard.tsx
var LocationLogEntryCard = ({ entryId, onClick }) => {
	const appInteractionHandlers = useAppInteractionHandlers();
	const { data, loading } = useLocationLogEntry(entryId && { entryId });
	const isClickable = Boolean(!data?.entry.deleted && (onClick || appInteractionHandlers?.onClickLocationLogEntry));
	if (!entryId) return null;
	if (!data?.entry) return null;
	return /* @__PURE__ */ jsx(Card, {
		className: classnames("bg-surface-subtle relative overflow-hidden", { "cursor-pointer": isClickable }),
		onClick: isClickable ? () => {
			if (onClick) onClick(entryId);
			else if (appInteractionHandlers?.onClickLocationLogEntry) appInteractionHandlers.onClickLocationLogEntry(entryId);
		} : void 0,
		space: "xxs",
		padding: "xxs",
		children: loading && !data ? /* @__PURE__ */ jsxs("div", {
			className: "w-full",
			children: [/* @__PURE__ */ jsx(Skeleton.Text, {}), /* @__PURE__ */ jsx(Skeleton.Text, {})]
		}) : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
			className: classnames({ "opacity-50": data.entry.deleted }, "flex flex-col"),
			children: [/* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs inline-flex w-full items-center justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "text-sm font-medium capitalize",
					children: [data.entry.entryType.color && /* @__PURE__ */ jsx(ColorSquare, {
						marginRight: true,
						color: data.entry.entryType.color
					}), data.entry.entryType.name]
				}), /* @__PURE__ */ jsx(DateTime$1, { timestamp: data.entry.timestamp })]
			}), /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs inline-flex w-full items-center justify-between",
				children: [/* @__PURE__ */ jsx("div", {
					className: "font-bold",
					children: !!data.entry.locationId && /* @__PURE__ */ jsx(LocationName, { locationId: data.entry.locationId })
				}), /* @__PURE__ */ jsx("div", {
					className: "gap-x-xxs truncate",
					children: data.entry.createdByUserId && /* @__PURE__ */ jsx(UserName, { user: data.entry.createdByUser })
				})]
			})]
		}), data.entry.deleted && /* @__PURE__ */ jsx("div", {
			className: "z-sticky bg-critical-faded text-color-critical p-sm absolute inset-0 flex items-center justify-center rounded font-bold tracking-wider",
			children: "DELETED"
		})] })
	});
};
//#endregion
export { LocationLogEntryCard };

//# sourceMappingURL=LocationLogEntryCard.js.map